import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_ORDER_ITEMS_FAILURE,
  FETCH_ORDER_ITEMS_REQUEST,
  FETCH_ORDER_ITEMS_SUCCESS,
  OrderItemsActionType,
  SET_ORDER_CACHE,
  SET_ORDER_DATE,
  SET_ORDER_FILTERS,
  SET_ORDER_PAYMENT_TYPE,
  TRIGGER_ORDERS_REFETCH,
} from '../types/orderItemsType';
import { OrderDateItems, OrderItems } from 'src/types/model';

export const fetchOrderItemsRequest = (): OrderItemsActionType => ({
  type: FETCH_ORDER_ITEMS_REQUEST,
});

export const fetchOrderItemsSuccess = (
  data: OrderItems
): OrderItemsActionType => ({
  type: FETCH_ORDER_ITEMS_SUCCESS,
  payload: data,
});

export const fetchOrderItemsFailure = (
  error: string
): OrderItemsActionType => ({
  type: FETCH_ORDER_ITEMS_FAILURE,
  payload: error,
});

export const fetchOrderItems = () => {
  return async (dispatch: Dispatch<OrderItemsActionType>) => {
    dispatch(fetchOrderItemsRequest());
    try {
      const request = await Service.get('/sales/info');
      const data: OrderItems = request?.data?.data;
      dispatch(fetchOrderItemsSuccess(data));
    } catch (error: any) {
      dispatch(fetchOrderItemsFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch items');
    }
  };
};

export const updateOrderDate = (
  data: OrderDateItems
): OrderItemsActionType => ({
  type: SET_ORDER_DATE,
  payload: data,
});

export const updateOrderItemsCache = (
  data: any
): OrderItemsActionType => ({
  type: SET_ORDER_CACHE,
  payload: data,
});

export const updateOrderFilters = (
  data: any
): OrderItemsActionType => ({
  type: SET_ORDER_FILTERS,
  payload: data,
});

export const updateOrderPaymentType = (
  data: any
): OrderItemsActionType => ({
  type: SET_ORDER_PAYMENT_TYPE,
  payload: data,
});

export const triggerOrdersRefetch = (value: boolean): OrderItemsActionType => ({
  type: TRIGGER_ORDERS_REFETCH,
  payload: value,
});